import { FC, SVGProps } from "react";

export const SettingsToolIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = "white",
  className,
  width = 18,
  height = 18,
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        ...style,
      }}
      {...props}
    >
      <path
        d="M15.9 8.5l-.2.4c-.1.2-.3.2-.5.2-.4-.1-.7-.3-1-.6-.1-.1-.2-.3-.1-.5l.2-.4c-.1-.3-.3-.6-.4-.9h-.5c-.2 0-.3-.1-.4-.3V5.2c0-.2.2-.3.4-.3h.5c.1-.3.3-.6.5-.9l-.2-.4c-.1-.2-.1-.4.1-.5.3-.2.6-.4 1-.6.2-.1.4 0 .5.2l.2.4c.3-.1.6-.1 1 0l.2-.4c.1-.2.3-.2.5-.2.4.1.7.3 1 .6.1.1.2.3.1.5l-.4.4c.2.3.4.5.5.9h.5c.2 0 .3.1.4.3.1.4.1.8 0 1.2 0 .2-.2.3-.4.3h-.5c-.1.3-.3.6-.5.9l.3.4c.1.2.1.4-.1.5-.3.2-.6.4-1 .6-.2.1-.4 0-.5-.2l-.2-.4h-1zm-.3-1.9c1.2.9 2.5-.4 1.6-1.7-1.2-.8-2.5.5-1.6 1.7zm-3.5 4.9l1 .5c.3.2.4.6.3.9-.3.8-.8 1.5-1.3 2.1-.2.3-.6.3-.9.2l-.9-.5c-.5.4-1.1.8-1.7 1v1.1c0 .4-.3.7-.6.7-.7.1-1.5.1-2.3 0-.4-.1-.6-.4-.6-.7v-1.1c-.6-.2-1.2-.6-1.7-1l-.9.5c-.3.2-.7.1-.9-.2-.5-.6-1-1.3-1.3-2.1-.1-.3 0-.7.3-.9l1-.5c-.1-.7-.1-1.3 0-2L.7 9C.4 8.8.2 8.4.4 8c.2-.7.7-1.4 1.2-2 .2-.3.6-.3.9-.2l.9.5c.5-.4 1.1-.8 1.7-1v-1c0-.4.2-.7.6-.7.7-.1 1.5-.1 2.3 0 .4.1.6.4.6.7v1.1c.6.2 1.2.6 1.7 1l.9-.5c.3-.2.7-.1.9.2.5.6 1 1.3 1.3 2.1.1.3 0 .7-.3.9l-1 .5c.1.5.1 1.2 0 1.9zm-3.6.6c1.8-2.4-.9-5.1-3.2-3.3-1.8 2.4.9 5.2 3.2 3.3z"
        fill={fill}
      ></path>
    </svg>
  );
};
